var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-closing view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c(
        "div",
        { staticClass: "view_content_markdown" },
        [
          _vm._l(_vm.getFlowViewContent, function (content) {
            return [
              content.type === "TITLE"
                ? _c("h1", [_vm._v(_vm._s(content.literal))])
                : _vm._e(),
              content.type === "PARAGRAPH"
                ? _c("p", [_vm._v(_vm._s(content.literal))])
                : _vm._e(),
              content.type === "BULLET"
                ? _c("span", { staticClass: "bullet" }, [
                    _c("img", {
                      staticClass: "icon",
                      attrs: {
                        src: require("@/assets/images/self-care/circlechecked.png"),
                      },
                    }),
                    _c("p", [_vm._v(_vm._s(content.literal))]),
                  ])
                : _vm._e(),
              content.type === "PARAGRAPH_ICON"
                ? _c("div", { staticClass: "end-content" }, [
                    _c("p", { staticClass: "end-img-text" }, [
                      _vm._v(_vm._s(content.literal)),
                    ]),
                    _c("img", {
                      staticClass: "end-img",
                      attrs: { src: content.image },
                    }),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _vm.hasMobilierTransition
          ? _c("ma-actions-buttons", {
              attrs: {
                handleButtonClick: _vm.handlePrimaryButtonClick,
                title: _vm.$t("claim.closing.actions.mobilierButton"),
                btnType: "functionalBtn",
              },
            })
          : _vm._e(),
        this.getFlowName === "ren_soggesur"
          ? _c("ma-actions-buttons", {
              attrs: {
                handleButtonClick: _vm.handleGoToTheURL,
                title: _vm.$t(
                  "Revenir sur mon espace Société générale Assurance"
                ),
                btnType: "functionalBtn",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }